
export default function LocationSection() {
  return (
    <section className="relative h-96 bg-gray-100">
      {/* Google Maps Embed */}
      <div className="absolute inset-0 w-full h-full">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048384.2896643467!2d-102.04816516865333!3d39.73915347800206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54eab584e432360b%3A0x1c3bb99243deb742!2sUnited%20States!5e0!3m2!1sen!2sus!4v1672234567890!5m2!1sen!2sus"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="AiCH Location - United States"
        ></iframe>
      </div>
      
      {/* Location Info Card */}
      <div className="absolute right-8 top-1/2 transform -translate-y-1/2 bg-white rounded-lg shadow-xl p-8 max-w-sm">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Location</h2>
        <p className="text-gray-600 mb-2">
          <i className="ri-map-pin-line text-emerald-600 mr-2"></i>
          United States
        </p>
        <p className="text-gray-600 mb-4">
          Serving industrial clients across the entire United States with cutting-edge AI solutions.
        </p>
        <div className="flex items-center text-emerald-600">
          <i className="ri-phone-line mr-2"></i>
          <span className="text-sm">Contact us for local support</span>
        </div>
      </div>
    </section>
  );
}
